import Vue from 'vue'
import Vuex from 'vuex'
import { authorizeApi, api } from '@/plugins/api'

let authToken = window.location.pathname.match(/\/dc2023\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/)
if (authToken && authToken.length === 2) {
  authToken = authToken[1]
  window.localStorage.setItem('dc2023-token', authToken)
} else {
  authToken = window.localStorage.getItem('dc2023-token')
}

authorizeApi(authToken)

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    authToken,
    lastLoadedDataTime: null,
    user: {},
    badges: [],
    superBadges: [],
    shopItems: [],
    shopOrders: [],
    groups: [],
    matches: [],
    players: {},
    teams: {},
    timelines: [],
    webVersion: null,
    content: []
  },
  getters: {
    fullTimeline: state => {
      return [...state.timelines, ...state.matches]
        .sort((a, b) => {
          if (a.day === b.day) {
            return parseFloat(a.timeStart.replace(':', '.')) - parseFloat(b.timeStart.replace(':', '.'))
          }
          return a.day - b.day
        })
    }
  },
  mutations: {
    setGroups (state, data) {
      state.groups = data.map((g, index) => {
        g.index = index + 1
        return g
      })
    },
    setMatches (state, data) {
      state.matches = data
    },
    setPlayers (state, data) {
      state.players = data.reduce((prev, next) => {
        prev[next.id] = next
        return prev
      }, {})
    },
    setTeams (state, data) {
      state.teams = data.reduce((prev, next) => {
        prev[next.id] = next
        return prev
      }, {})
    },
    setTimelines (state, data) {
      state.timelines = data
    },
    setUser (state, data) {
      state.user = data
    },
    setShopItems (state, data) {
      state.shopItems = data
    },
    setShopOrders (state, data) {
      state.shopOrders = data
    },
    setBadges (state, data) {
      state.badges = data
    },
    setSuperBadges (state, data) {
      state.superBadges = data
    },
    setContent (state, data) {
      state.content = data.reduce((res, content) => {
        const index = res.findIndex(c => c.id === content.parentId)
        if (index >= 0) {
          res[index].links.push(content)
        } else {
          res.push({
            id: content.parentId,
            title: content.parentTitle,
            links: [
              content
            ]
          })
        }
        return res
      }, [])
    },
    setWebVersion (state, data) {
      state.webVersion = data
    },
    setLastLoadedDataTime (state, data) {
      state.lastLoadedDataTime = data
    }
  },
  actions: {
    loadData ({ commit, state }, force = true) {
      if (!force && state.lastLoadedDataTime !== null && (+new Date()) - state.lastLoadedDataTime < 60000) {
        return true
      }
      commit('setLastLoadedDataTime', +new Date())
      return api.fetchData().then(response => {
        commit('setBadges', (response.data.badgesAll || []).filter(b => !b.isSuper))
        commit('setSuperBadges', (response.data.badgesAll || []).filter(b => b.isSuper))
        commit('setContent', response.data.content || [])
        commit('setGroups', response.data.groups || [])
        commit('setPlayers', response.data.players || [])
        commit('setTeams', response.data.teams || [])
        commit('setMatches', response.data.matches || [])
        commit('setTimelines', response.data.timelines || [])
        commit('setShopItems', response.data.shopItems || [])
        commit('setShopOrders', response.data.shopOrders || [])
        commit('setUser', response.data.user || {})
        commit('setWebVersion', response.data.webVersion || '1.0.0')
        commit('setLastLoadedDataTime', +new Date())
        return true
      })
    },
    savePlayer ({ commit, dispatch, state }, { playerId, photoData, data }) {
      return api.patchDetails({
        playerId,
        photoData,
        ...data
      }).then(_ => dispatch('loadData'))
    },
    patchBadge ({ commit, dispatch }, { playerId, badge, value }) {
      return api.adminPatchBadge({
        playerId,
        badge,
        value: value ? 1 : 0
      }).then(_ => dispatch('loadData'))
    },
    patchIsAdmin ({ commit, dispatch }, { playerId }) {
      return api.adminPatchIsAdmin({
        playerId
      }).then(_ => dispatch('loadData'))
    },
    patchCityGame ({ commit, dispatch }, { playerId, data }) {
      return api.adminPatchCityGame({
        playerId,
        ...data
      }).then(_ => dispatch('loadData'))
    },
    patchMatch ({ commit, dispatch }, { matchId, data }) {
      return api.adminPatchMatch({
        matchId,
        ...data
      }).then(_ => dispatch('loadData'))
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
